import React, { useEffect, useState } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Grid from '@material-ui/core/Grid';
import TimePickerDropDown from './TimePickerDropDown';
import Checkbox from '@material-ui/core/Checkbox';
import { useDispatch } from 'react-redux';
import { setOperationHour } from '../../redux/actions/operationHoursActions';
import { times as dropdownTimes } from '../../utils/utils';
import { Typography } from '@material-ui/core';

interface ZLIIProps {
  primary: string;
  isDayPart?: boolean;
  isDisabledByDate?: boolean;
  secondary?: string;
  firstTName?: string;
  secondTName?: string;
  checkedAll?: boolean;
  checkedAllTF?: boolean;
  isDisabled?: boolean;
  checked: string[];
  checkedClose: string[];
  index: number;
  handleChecked: (value: string[]) => void;
  handleCheckedClose: (value: string[]) => void;
  startTime: string;
  startTimeMode?: string[];
  endTime?: string;
  endTimeMode?: string[];
  startTimeName: string;
  endTimeName?: string;
  twentyFourHourName?: string;
  closeHourName?: string;
  setEdited: Function;
  hasCheckboxes?: boolean;
  enableDhTime24hr?: boolean;
  tooltipTitle?: string;
  times?: string[];
  hasEditPermission?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      borderBottom: '1px solid',
      borderBottomColor: '#bdbdbd',
      marginTop: 5,
    },
    demo: {
      backgroundColor: '#f5f5f5',
    },
    title: {
      margin: theme.spacing(1, 0, 1),
    },
  }),
);

export default function InteractiveList({
  primary,
  secondary,
  isDisabled,
  firstTName,
  secondTName,
  checked,
  checkedClose,
  handleChecked,
  handleCheckedClose,
  index,
  startTime,
  startTimeMode = ['read', 'write'],
  endTime,
  endTimeMode = ['read', 'write'],
  startTimeName,
  endTimeName,
  twentyFourHourName,
  closeHourName,
  setEdited,
  hasCheckboxes,
  enableDhTime24hr,
  isDisabledByDate,
  tooltipTitle = '',
  times = dropdownTimes,
  isDayPart,
  hasEditPermission = true
}: ZLIIProps) {
  const classes = useStyles();
  const dispatch: any = useDispatch();
  const indexOfTime = times.indexOf(startTime);
  const handleChangeCB = (index: number) => {
    dispatch(setEdited(true));
    if (checked[index] === 'N') {
      if (checkedClose[index] && checked[index] !== checkedClose[index]) {
        let newArrClose = [...checkedClose];
        newArrClose[index] = 'N';
        handleCheckedClose(newArrClose);
        dispatch(
          setOperationHour({
            hourName: closeHourName,
            hourValue: 'N',
          }),
        );
      }
    }
    let newArr = [...checked];
    newArr[index] = checked[index] === 'Y' ? 'N' : 'Y';
    handleChecked(newArr);
    dispatch(
      setOperationHour({
        hourName: twentyFourHourName,
        hourValue: checked[index] === 'Y' ? 'N' : 'Y',
      }),
    );
  };

  const handleChangeClose = (index: number) => {
    dispatch(setEdited(true));
    if (checkedClose[index] === 'N') {
      if (checkedClose[index] !== checked[index]) {
        let newArr = [...checked];
        newArr[index] = 'N';
        handleChecked(newArr);
        dispatch(
          setOperationHour({
            hourName: twentyFourHourName,
            hourValue: 'N',
          }),
        );
      }
    }
    let newArrClose = [...checkedClose];
    newArrClose[index] = checkedClose[index] === 'Y' ? 'N' : 'Y';
    handleCheckedClose(newArrClose);
    dispatch(
      setOperationHour({
        hourName: closeHourName,
        hourValue: checkedClose[index] === 'Y' ? 'N' : 'Y',
      }),
    );
  };
  const [disabled, setDisabled] = useState<boolean>(false);
  useEffect(() => {
    setDisabled(checked[index] === 'Y' || checkedClose[index] === 'Y');
  }, [checked, checkedClose, index]);

  return (
    <>
      {startTimeMode.length || endTimeMode.length ? (
        <div className={classes.root}>
          <Grid container spacing={0}>
            <Grid item xs={4} md={4}>
              <div className={classes.demo}>
                <List>
                  <ListItem style={isDayPart ?
                    { padding: "0px 16px 0px 16px" } :
                    { padding: "8px 16px 16px 16px" }
                  }>
                    <ListItemText primary={primary} />
                  </ListItem>
                  {isDayPart ?
                    <ListItem style={{ padding: "0px 16px 0px 16px" }}>
                      <ListItemText
                        disableTypography
                        primary={
                          <Typography
                            variant="caption"
                            display="inline"
                            style={{
                              background: "#d4d8d9",
                              color: "black",
                              borderRadius: "10px",
                              padding: "5px"
                            }}>
                            {secondary}
                          </Typography>
                        }
                      />
                    </ListItem> : null}
                </List>
              </div>
            </Grid>

            <Grid item xs={2} md={2}>
              {hasCheckboxes && !enableDhTime24hr && (
                <>
                  <Checkbox
                    disabled={isDisabledByDate || !hasEditPermission}
                    style={{ marginTop: 10 }}
                    checked={checked[index] === 'Y'}
                    onChange={() => handleChangeCB(index)}
                  />
                  <Checkbox
                    disabled={isDisabledByDate || !hasEditPermission}
                    style={{ marginTop: 10 }}
                    checked={checkedClose[index] === 'Y'}
                    onChange={() => handleChangeClose(index)}
                  />
                </>
              )}
              {hasCheckboxes && enableDhTime24hr && (
                <>
                  <Checkbox
                    disabled={isDisabledByDate || !hasEditPermission}
                    style={{ marginTop: 10 }}
                    checked={checked[index] === 'Y'}
                    onChange={() => handleChangeCB(index)}
                  />
                </>
              )}
            </Grid>
            <Grid item xs={3} md={3}>
              {firstTName && startTimeMode.length && (
                <TimePickerDropDown
                  times={times}
                  disabled={enableDhTime24hr && startTimeName === 'deliveryTimeOpen' ? disabled : disabled || !startTimeMode?.includes('write')}
                  isDropDownDisabled={isDisabled}
                  tName={firstTName}
                  time={startTime ? startTime?.substring(0, 5) : ''}
                  timeName={startTimeName}
                  setEdited={setEdited}
                  tooltip={tooltipTitle}
                  setOperationHour={setOperationHour}
                  hasCheckboxes={hasCheckboxes}
                  enableDhTime24hr={enableDhTime24hr}
                  hasEditPermission={hasEditPermission}
                />
              )}
            </Grid>
            <Grid item xs={3} md={3}>
              {secondTName && endTimeMode.length && (
                <TimePickerDropDown
                  times={
                    indexOfTime > 0 && !isDayPart
                      ? [...times.filter((_, i) => i > indexOfTime)]
                      : times
                  }
                  disabled={enableDhTime24hr && endTimeName === 'deliveryTimeClose' ? disabled : disabled || !startTimeMode?.includes('write')}
                  tName={secondTName}
                  isDropDownDisabled={isDisabled}
                  time={endTime ? endTime?.substring(0, 5) : ''}
                  timeName={endTimeName ? endTimeName : ''}
                  setEdited={setEdited}
                  tooltip={tooltipTitle}
                  setOperationHour={setOperationHour}
                  hasCheckboxes={hasCheckboxes}
                  enableDhTime24hr={enableDhTime24hr}
                  hasEditPermission={hasEditPermission}
                />
              )}
            </Grid>
          </Grid>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
